import React from 'react'
import slugify from 'react-slugify';
import { vuiDateDistance } from '@topkamera/viso-ui'
import { recentActionsMap } from 'containers/HomePage/constants'
import { getIncident } from 'api/incident'
import { filterByDateRange } from 'components/AskViso/utils'
import NotificationListPeriod from './NotificationListPeriod'
import './NotificationList.scss'

const NotificationList = ({
  list = [], markAsReadNotification, router, workspace, setNotificationList, onClose
}) => {

  const mapNotifications = () => {
    let items = []
    list.forEach((item) => {
      const getCategoryDetails = recentActionsMap[item.category]
      items.push({
        captions: [getCategoryDetails?.label || item.category],
        icon: getCategoryDetails?.icon || 'timeSync',
        showIndicator: !item.readState,
        timeStamp: item.createdAt && vuiDateDistance({ date: item.createdAt }),
        createdAt: item.createdAt,
        itemData: item,
        url: getCategoryDetails?.url
      })
    })
    return items
  }

  const { today = [], yesterday = [], previous7Days = [], previous30Days = [], older = [] } = filterByDateRange(mapNotifications())
  const sortByCreatedAtDesc = (items = []) => (
    [...items].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  )

  const todayItems = sortByCreatedAtDesc(today)
  const yesterdayItems = sortByCreatedAtDesc(yesterday)
  const earlierItems = sortByCreatedAtDesc([...previous7Days, ...previous30Days, ...older])

  const onNotificationClick = async (id) => {
    markAsReadNotification({ id })
    const updateRead = list.map((item) => item._id === id ? { ...item, readState: true } : item)
    setNotificationList(updateRead)
    const findNotification = list.find((item) => item._id === id)
    if (findNotification) {
      const getCategoryDetails = recentActionsMap[findNotification?.category]
      const isRemoveAction = findNotification?.message?.includes('removed.')
      if (isRemoveAction) return null

      if (findNotification?.category === 'incident' && findNotification?.resourceId) {
        const incidentData = await getIncident({ id: findNotification.resourceId })
        const incident = incidentData?.data?.data?.incident

        if (incident?._id && incident?.incidentBoardId) {
          onClose()
          return router.navigate(`/${slugify(workspace.name)}/${getCategoryDetails.url}/${incident.incidentBoardId}/${incident._id}`)
        }
      }

      if (getCategoryDetails?.noIdPage) {
        router.navigate(`/${slugify(workspace.name)}/${getCategoryDetails.url}`)
      } else if (getCategoryDetails?.url) {
        router.navigate(`/${slugify(workspace.name)}/${getCategoryDetails.url}/${findNotification.resourceId}`)
      }
    }
  }

  const mapAccent = () => {
    const accents = ['accent0', 'accent1', 'accent2']
    const visiblePeriods = [
      { key: 'today', items: todayItems },
      { key: 'yesterday', items: yesterdayItems },
      { key: 'earlier', items: earlierItems }
    ].filter(({ items }) => items.length > 0)

    return visiblePeriods.reduce((acc, { key }, idx) => {
      acc[key] = accents[idx] || accents[accents.length - 1]
      return acc
    }, {})
  }

  const accentByPeriod = mapAccent()

  return (
    <div className='vui-flex vui-flex-column vui-gap-20 viso-notification-list'>
      <NotificationListPeriod
        items={todayItems}
        color={accentByPeriod.today}
        onClick={onNotificationClick}
        title='Today'
      />
      <NotificationListPeriod
        items={yesterdayItems}
        color={accentByPeriod.yesterday}
        onClick={onNotificationClick}
        title='Yesterday'
      />
      <NotificationListPeriod
        items={earlierItems}
        color={accentByPeriod.earlier}
        onClick={onNotificationClick}
        title='Earlier'
      />
    </div>
  )
}

export default NotificationList